export var ChatEventStream;
(function (ChatEventStream) {
    /**
     * The type of event.
     */
    let event;
    (function (event) {
        event["MESSAGE_START"] = "message_start";
        event["CONTENT_BLOCK_START"] = "content_block_start";
        event["CONTENT_BLOCK_DELTA"] = "content_block_delta";
        event["CONTENT_BLOCK_END"] = "content_block_end";
        event["MESSAGE_STOP"] = "message_stop";
    })(event = ChatEventStream.event || (ChatEventStream.event = {}));
})(ChatEventStream || (ChatEventStream = {}));
